import arrowLeft from '@/assets/arrowsvg.svg';
import { useViewTransition } from '@/hooks/useViewTransition';
import { useSwipeDetection } from '@/hooks/useSwipeDetection';
import { useModal } from '@/hooks/useModal';

export function SecondaryHeader({ text }: { text: string }) {
  const { navigateBack } = useViewTransition();
  const { isModalOpen } = useModal();
  
  const handleBack = () => {
    if (isModalOpen) {
      return;
    }
    navigateBack('/index');
  };

  useSwipeDetection({
    minSwipeDistance: 50,
    onSwipeRight: () => {
      handleBack();
    }
  });

  return (
    <header className="text-white w-full flex items-center pb-3">
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button className="text-white text-left" onClick={handleBack}>
        <img src={arrowLeft} alt='back' className='h-6 translate-y-[1px]'/>
      </button>
      <h1 className="text-white text-2xl flex-1 text-center mr-6 font-bold">
        {text}
      </h1>
    </header>
  );
};